import React from "react";
import "../../Styles/yellowcalf.css/Transportation_Details.css";

const demoRows = [
  {
    id: 1,
    studentName: "testSTudent",
    grade: "1st A",
    matricule: "9898545454",
    parentName: "harisfather",
    tripType: "pickup",
    vehicle: "Samsung Vehicle",
    trip: "Galaxy Scheduled Shift two",
    busStop: "Mental Hospital Corner Mohanwadi",
    distance: "1590.76",
  },
  {
    id: 2,
    studentName: "testSTudent",
    grade: "1st A",
    matricule: "9898545454",
    parentName: "harisfather",
    tripType: "pickup",
    vehicle: "MH04AB04",
    trip: "Drop Trip",
    busStop: "Pune MB Shivaji Nagar fargson college behind.pandavnagar",
    distance: "1582.99",
  },
];

function Transportation_Details() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Transportation Details</h4>
        <button className="btn btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select id="student_id" className="form-select" name="student">
            <option value="">Select Student</option>
            <option value="256">anju - 3567643</option>
            <option value="270">ansh - 827714</option>
            <option value="272">ansh - 827714</option>
            <option value="268">ansh - 958884</option>
          </select>

          <select id="class_id" className="form-select" name="student_class">
            <option value="">Select Grade</option>
            <option value="1">KG1 A</option>
            <option value="56">NURSERY 1 A</option>
            <option value="59">10th A</option>
            <option value="30">XII A</option>
            <option value="38">1st A</option>
          </select>

          <select id="parent_id" className="form-select" name="parent">
            <option value="">Select Parent</option>
            <option value="16122">23422</option>
            <option value="16642">achan</option>
            <option value="55181">akbar</option>
            <option value="33913">alex</option>
          </select>

          <select id="trip_type" name="trip_type" className="form-select">
            <option value="">Select Trip Type</option>
            <option value="pickup">Pickup</option>
            <option value="drop">Drop</option>
            <option value="both">Both</option>
          </select>

          <select id="trip_id" className="form-select" name="trip">
            <option value="">Select Trip</option>
            <option value="256">16_06_1_a</option>
            <option value="255">bial</option>
            <option value="88">Drop Trip</option>
            <option value="63">Europe Trip</option>
          </select>

          <button className="btn btn-primary" id="clear">
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-10">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">Matricule (ID)</div>
            <div className="yc-list-cell">Parent Name</div>
            <div className="yc-list-cell">Trip Type</div>
            <div className="yc-list-cell">Vehicle</div>
            <div className="yc-list-cell">Trip</div>
            <div className="yc-list-cell">Bus Stop</div>
            <div className="yc-list-cell">Distance</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {demoRows.map((row) => (
            <div key={row.id} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-10">
                <div className="yc-list-cell">{row.id}</div>
                <div className="yc-list-cell">{row.studentName}</div>
                <div className="yc-list-cell">{row.grade}</div>
                <div className="yc-list-cell">{row.matricule}</div>
                <div className="yc-list-cell">{row.parentName}</div>
                <div className="yc-list-cell">{row.tripType}</div>
                <div className="yc-list-cell">{row.vehicle}</div>
                <div className="yc-list-cell">{row.trip}</div>
                <div className="yc-list-cell">{row.busStop}</div>
                <div className="yc-list-cell">{row.distance}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Transportation_Details;
